import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Divider, Dropdown, MenuProps, Space, theme } from 'antd'
import { Link } from 'gatsby'
import routes from 'routes/routes'

const { useToken } = theme
export default function LoginDropdown() {
    const { token } = useToken()
    const { t } = useTranslation()

    const dropdownItems: MenuProps['items'] = [
        {
            key: '1',
            label: <Link to={routes.aboutLogin}>{t('about_login')}</Link>,
        },
    ]

    const contentStyle: React.CSSProperties = {
        backgroundColor: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
    }

    const menuStyle: React.CSSProperties = {
        boxShadow: 'none',
    }
    return (
        <Dropdown
            menu={{ items: dropdownItems }}
            dropdownRender={(menu) => (
                <div style={contentStyle}>
                    {React.cloneElement(menu as React.ReactElement, {
                        style: menuStyle,
                    })}
                    <Divider style={{ margin: 0 }} />
                    <Space style={{ padding: '10px 16px' }}>
                        <Link to={routes.login}>
                            <Button type="primary">{t('log_in')}</Button>
                        </Link>
                    </Space>
                </div>
            )}
        >
            <Button size="small" type="primary" tabIndex={-1}>
                {t('log_in')}
            </Button>
        </Dropdown>
    )
}
